/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/**
 * Enum with the possible notification UI events.
 */
export enum NotificationEvents {
    Close = 'Close',
    StartDismissing = 'StartDismissing',
    FinishDismissing = 'FinishDismissing',
    PreventDismissing = 'PreventDismissing',
    RemovedFromList = 'RemovedFromList'
}
